export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_TRACKING_ID ?? ''

export const event = (action: Gtag.EventNames, { event_category, event_label, value }: Gtag.EventParams) => {
  if (typeof window === 'undefined') return

  window.gtag('event', action, { event_category, event_label, value })
}
